import React, { useState } from 'react';
import PageHero from './PageHero';
import {
  CreditCard,
  Sparkles,
  Percent,
  CheckCircle2,
  Check,
  Info,
  ArrowRight,
  Briefcase,
  Layers,
  Download,
  FileText,
  AlertCircle,
  Loader2
} from 'lucide-react';
import heroImg from '../assets/Banner-GMIS Students.png';

export default function FeesTuitionPage({ setPage, t }) {
  // Localization data from t with fallback
  const content = t?.schoolFees || {};
  const ts = content?.tableSection || {};
  const appFee = content?.applicationFee || {};
  const disc = content?.discountsSection || {};
  const corp = content?.corporatePartnerships || {};
  const cta = content?.cta || {};

  const [stageFilter, setStageFilter] = useState('all');

  const rows = ts?.rows || [
    {
      stage: 'Preschool',
      stageKey: 'preschool',
      group: 'Toddler',
      fee: 'Rp. 70,000,000',
      rawFee: 70000000,
      badgeColor: 'bg-amber-500/10 text-amber-700 border-amber-200'
    },
    {
      stage: 'Preschool',
      stageKey: 'preschool',
      group: 'Nursery',
      fee: 'Rp. 94,245,000',
      rawFee: 94245000,
      badgeColor: 'bg-amber-500/10 text-amber-700 border-amber-200'
    },
    {
      stage: 'Preschool',
      stageKey: 'preschool',
      group: 'Kindergarten',
      fee: 'Rp. 98,365,000',
      rawFee: 98365000,
      badgeColor: 'bg-amber-500/10 text-amber-700 border-amber-200'
    },
    {
      stage: 'Preschool',
      stageKey: 'preschool',
      group: 'Preparatory',
      fee: 'Rp. 102,485,000',
      rawFee: 102485000,
      badgeColor: 'bg-amber-500/10 text-amber-700 border-amber-200'
    },
    {
      stage: 'Primary School',
      stageKey: 'primary',
      group: 'Primary School (Grade 1–5)',
      fee: 'Rp. 131,325,000',
      rawFee: 131325000,
      badgeColor: 'bg-blue-500/10 text-blue-700 border-blue-200'
    },
    {
      stage: 'Middle School',
      stageKey: 'middle',
      group: 'Middle School (Grade 6–8)',
      fee: 'Rp. 154,500,000',
      rawFee: 154500000,
      badgeColor: 'bg-emerald-500/10 text-emerald-700 border-emerald-200'
    },
    {
      stage: 'Senior School',
      stageKey: 'senior',
      group: 'Senior School (Grade 9–10)',
      fee: 'Rp. 181,280,000',
      rawFee: 181280000,
      badgeColor: 'bg-indigo-500/10 text-indigo-700 border-indigo-200'
    },
    {
      stage: 'Senior School',
      stageKey: 'senior',
      group: 'Senior School (Grade 11–12)',
      fee: 'Rp. 204,970,000',
      rawFee: 204970000,
      badgeColor: 'bg-purple-500/10 text-purple-700 border-purple-200'
    }
  ];

  const filteredRows = rows.filter(item => {
    if (stageFilter === 'all') return true;
    const itemStage = (item.stageKey || item.stage || '').toLowerCase();
    return itemStage.includes(stageFilter);
  });

  // Download Form State
  const [downloadFormData, setDownloadFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    whatsapp: ''
  });
  const [isSubmittingDownload, setIsSubmittingDownload] = useState(false);
  const [downloadFormSubmitted, setDownloadFormSubmitted] = useState(false);
  const [downloadFormError, setDownloadFormError] = useState('');
  const [leadReferenceId, setLeadReferenceId] = useState('');

  const triggerPdfDownload = () => {
    try {
      const pdfUrl = `${process.env.PUBLIC_URL || ''}/sample.pdf`;
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.setAttribute('download', 'GMIS-School-Fees-2027-2028.pdf');
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Download trigger error:', err);
    }
  };

  const handleDownloadInputChange = (e) => {
    const { name, value } = e.target;
    setDownloadFormData(prev => ({ ...prev, [name]: value }));
    if (downloadFormError) setDownloadFormError('');
  };

  const handleDownloadFormSubmit = (e) => {
    e.preventDefault();
    if (
      !downloadFormData.firstName.trim() ||
      !downloadFormData.lastName.trim() ||
      !downloadFormData.email.trim() ||
      !downloadFormData.whatsapp.trim()
    ) {
      setDownloadFormError(
        t?.utilAdm === 'Penerimaan'
          ? 'Harap lengkapi semua kolom wajib (Nama Depan, Nama Belakang, Email, dan WhatsApp).'
          : 'Please complete all required fields (First Name, Last Name, Email, and WhatsApp).'
      );
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(downloadFormData.email.trim())) {
      setDownloadFormError(
        t?.utilAdm === 'Penerimaan'
          ? 'Format email tidak valid. Harap periksa kembali.'
          : 'Please enter a valid email address.'
      );
      return;
    }

    setIsSubmittingDownload(true);
    setDownloadFormError('');

    setTimeout(() => {
      const generatedId = `GMIS-LEAD-${Math.floor(1000 + Math.random() * 9000)}`;
      setLeadReferenceId(generatedId);

      // Record lead in CRM / LocalStorage
      try {
        const leadRecord = {
          id: generatedId,
          parentName: `${downloadFormData.firstName.trim()} ${downloadFormData.lastName.trim()}`,
          firstName: downloadFormData.firstName.trim(),
          lastName: downloadFormData.lastName.trim(),
          email: downloadFormData.email.trim(),
          whatsapp: downloadFormData.whatsapp.trim(),
          academicYear: content.academicYear || 'Academic Year 2027–2028',
          requestedFile: 'GMIS-School-Fees-2027-2028.pdf',
          submittedAt: new Date().toISOString(),
          source: 'Website Fees & Tuition Download Form'
        };
        const existingLeads = JSON.parse(localStorage.getItem('gmis_crm_leads') || '[]');
        existingLeads.push(leadRecord);
        localStorage.setItem('gmis_crm_leads', JSON.stringify(existingLeads));
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new CustomEvent('gmis_lead_recorded', { detail: leadRecord }));
        }
        console.log('[GMIS CRM] New lead recorded:', leadRecord);
      } catch (storageErr) {
        console.warn('Could not persist lead to localStorage:', storageErr);
      }

      // Automatically trigger file download
      triggerPdfDownload();

      setIsSubmittingDownload(false);
      setDownloadFormSubmitted(true);
    }, 600);
  };

  const handleResetDownloadForm = () => {
    setDownloadFormData({
      firstName: '',
      lastName: '',
      email: '',
      whatsapp: ''
    });
    setDownloadFormSubmitted(false);
    setDownloadFormError('');
  };

  const handleNavigateToContact = () => {
    if (setPage) setPage('contact');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateToFaqs = () => {
    if (setPage) setPage('faqs');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navCategory = t?.nav?.[5]?.label || "Admissions";
  const homeLabel = t?.nav?.[0]?.label || "Home";

  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen text-ink">
      {/* ── Page Hero ────────────────────────────────────────────── */}
      <PageHero
        title={content.title || 'School Fees & Tuition'}
        eyebrow={content.eyebrow || navCategory}
        subtitle={content.subtitle || 'Clear, transparent tuition and flexible payment plans designed to support families investing in their child’s future.'}
        breadcrumbs={content.breadcrumbs || [homeLabel, navCategory, 'Fees & Tuition']}
        bgImage={heroImg}
      />

      {/* ── Top Floating Action Bar ──────────────────────────────────── */}
      <section className="relative -mt-10 z-20 max-w-[1240px] mx-auto px-6 box-border">
        <div className="bg-white rounded-2xl p-5 lg:p-7 shadow-xl border border-line flex flex-col lg:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-4 w-full lg:w-auto">
            <div className="w-13 h-13 rounded-2xl bg-gold/15 flex items-center justify-center text-gold-ink shrink-0">
              <CreditCard className="w-7 h-7 text-gold-ink" />
            </div>
            <div>
              <div className="text-[11px] font-bold tracking-[0.2em] text-gold uppercase mb-1">
                {content.academicYear || 'Academic Year 2027–2028'}
              </div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-navy m-0 uppercase">
                Transparent & Flexible School Fees
              </h2>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3 w-full lg:w-auto">
            <button
              onClick={() => scrollToSection('fees-table')}
              className="btn flex-1 sm:flex-initial inline-flex items-center justify-center gap-2 h-11 px-5 rounded-xl bg-gold text-navy-deep font-heading font-bold text-[13px] tracking-wider uppercase transition-all shadow-md hover:shadow-lg"
            >
              <span>Annual Fees Table</span>
              <ArrowRight className="w-4 h-4" />
            </button>
            <button
              onClick={() => scrollToSection('download-fees-pdf')}
              className="btn flex-1 sm:flex-initial inline-flex items-center justify-center gap-2 h-11 px-5 rounded-xl border border-navy/20 bg-paper text-navy font-heading font-bold text-[13px] tracking-wider uppercase hover:bg-white transition-all cursor-pointer"
            >
              <Download className="w-4 h-4 text-gold-ink" />
              <span>Download PDF</span>
            </button>
            <button
              onClick={() => scrollToSection('discounts')}
              className="btn flex-1 sm:flex-initial inline-flex items-center justify-center gap-2 h-11 px-5 rounded-xl border border-navy/20 bg-paper text-navy font-heading font-bold text-[13px] tracking-wider uppercase hover:bg-white transition-all"
            >
              <Percent className="w-4 h-4 text-gold-ink" />
              <span>Discounts</span>
            </button>
          </div>
        </div>
      </section>

      {/* ── Main Container ────────────────────────────────────────────── */}
      <div className="max-w-[1240px] mx-auto px-6 lg:px-[60px] py-14 lg:py-20 box-border">

        {/* ── Section 1: Annual School Fees Table ────────────────────────── */}
        <div id="fees-table" className="mb-20 scroll-mt-28">
          <div className="text-center max-w-3xl mx-auto mb-10">
            <div className="inline-flex items-center gap-2 mb-3 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10">
              <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">
                {ts.eyebrow || 'Transparent Tuition'}
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-[40px] font-heading font-bold text-navy tracking-tight m-0 leading-tight uppercase">
              {ts.title || 'Annual School Fees'}
            </h2>
            <div className="inline-block mt-3 mb-3 px-4 py-1 rounded-full bg-navy/5 text-navy font-semibold text-[13px]">
              {ts.yearBadge || 'Academic Year 2027–2028'}
            </div>
            <p className="text-[16px] md:text-[17px] text-muted leading-relaxed m-0">
              {ts.subtitle || 'All fees are quoted in Indonesian Rupiah (IDR).'}
            </p>
          </div>

          {/* Interactive Filters */}
          <div className="bg-white rounded-2xl p-5 md:p-6 border border-line shadow-sm mb-7">
            {/* School Stage Filters */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-[12px] font-bold uppercase tracking-wider text-muted mr-1.5 flex items-center gap-1.5 shrink-0">
                  <Layers className="w-4 h-4 text-gold" /> {ts.filterLabel || 'Filter Stage:'}
                </span>
                {[
                  { id: 'all', label: ts.filterAll || 'All Stages' },
                  { id: 'preschool', label: ts.stages?.preschool || 'Preschool' },
                  { id: 'primary', label: ts.stages?.primary || 'Primary School' },
                  { id: 'middle', label: ts.stages?.middle || 'Middle School' },
                  { id: 'senior', label: ts.stages?.senior || 'Senior School' }
                ].map(f => (
                  <button
                    key={f.id}
                    onClick={() => setStageFilter(f.id)}
                    className={`px-3.5 py-1.5 rounded-xl text-[13px] font-heading font-semibold transition-all cursor-pointer ${stageFilter === f.id
                      ? 'bg-navy text-white shadow-sm'
                      : 'bg-paper text-ink/80 hover:bg-gold/15 hover:text-navy'
                      }`}
                  >
                    {f.label}
                  </button>
                ))}
              </div>

              {/* Stage Counter */}
              <div className="text-[12.5px] font-medium text-muted shrink-0 hidden lg:block">
                {t?.utilAdm === 'Penerimaan'
                  ? `Menampilkan ${filteredRows.length} program`
                  : `Showing ${filteredRows.length} ${filteredRows.length === 1 ? 'level' : 'levels'}`}
              </div>
            </div>
          </div>

          {/* Fees Table */}
          <div className="bg-white rounded-2xl border border-line shadow-md overflow-hidden mb-6">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse text-left">
                <thead>
                  <tr className="bg-navy text-white text-[12.5px] font-heading font-bold uppercase tracking-wider border-b border-navy-deep">
                    <th className="py-4 px-6 md:px-8 w-[50%]">
                      {ts.columns?.stage || 'School Stage / Year Group'}
                    </th>
                    <th className="py-4 px-6 md:px-8 w-[50%] text-right">
                      {ts.columns?.fee || 'Annual School Fee'}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-line/70 text-[15px]">
                  {filteredRows.map((item, index) => (
                    <tr
                      key={index}
                      className={`transition-colors duration-200 ${index % 2 === 0
                        ? 'bg-white hover:bg-paper/60'
                        : 'bg-[#fcfdfd] hover:bg-paper/60'
                        }`}
                    >
                      {/* Stage & Group */}
                      <td className="py-4 px-6 md:px-8 align-middle">
                        <div className="flex items-center gap-3">
                          <span className={`px-2.5 py-0.5 rounded-md text-[11px] font-bold uppercase tracking-wider border ${item.badgeColor || 'bg-navy/5 text-navy border-line'}`}>
                            {item.stage}
                          </span>
                          <span className="font-heading font-bold text-navy text-[15px] md:text-[16px]">
                            {item.group}
                          </span>
                        </div>
                      </td>

                      {/* Fee */}
                      <td className="py-4 px-6 md:px-8 text-right align-middle font-heading font-bold text-navy text-[16px] md:text-[18px]">
                        <span className="inline-block px-3 py-1 rounded-lg bg-paper text-navy font-mono">
                          {item.fee}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Application Fee Feature Bar inside Table footer */}
            <div className="bg-gold/10 border-t border-gold/30 px-6 md:px-8 py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-ink">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-gold text-navy-deep flex items-center justify-center shrink-0">
                  <Info className="w-4 h-4" />
                </div>
                <div>
                  <span className="font-heading font-bold text-navy text-[14px] block">
                    {appFee.title || 'Application Fee'}
                  </span>
                  <span className="text-muted text-[13px]">
                    {appFee.desc || 'A non-refundable Application Submission Fee of IDR 5,000,000 is payable once upon admission.'}
                  </span>
                </div>
              </div>
              <div className="shrink-0 font-heading font-bold text-navy text-[16px] sm:text-right pl-11 sm:pl-0">
                {appFee.amount || 'IDR 5,000,000'}
              </div>
            </div>
          </div>
        </div>

        {/* ── Section 2: Download Full PDF School Fees ───────────────────── */}
        <div id="download-fees-pdf" className="mb-20 scroll-mt-28">
          {/* Centered blue accent line like in the reference */}
          <div className="w-16 h-1 bg-[#1e40af] mx-auto mb-12 rounded-full" />

          <div className="bg-[#fcfdfd] rounded-2xl md:rounded-3xl p-6 sm:p-8 lg:p-12 border border-line shadow-sm">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">

              {/* Left Column: Heading & Description */}
              <div className="lg:col-span-5 flex flex-col justify-center">
                <div className="inline-flex items-center gap-2 mb-3 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10 w-fit">
                  <FileText className="w-3.5 h-3.5 text-gold" />
                  <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">
                    {t?.utilAdm === 'Penerimaan' ? 'Dokumen Resmi' : 'Official Document'}
                  </span>
                </div>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy leading-tight uppercase mb-4">
                  {t?.utilAdm === 'Penerimaan'
                    ? 'Unduh PDF Lengkap Biaya Sekolah 2027–2028'
                    : 'Download Full PDF School Fees 2027–2028'}
                </h2>
                <p className="text-[15.5px] text-ink/75 leading-relaxed mb-6">
                  {t?.utilAdm === 'Penerimaan'
                    ? 'Jika Anda menginginkan rincian lengkap Biaya Sekolah 2027–2028 dalam format PDF, silakan kirimkan permintaan Anda di sini.'
                    : 'If you would like the full details of the School Fees 2027–2028 in PDF format, submit your request here.'}
                </p>

                <div className="bg-white p-4 rounded-2xl border border-line/70 space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-xl bg-gold/15 text-gold-ink flex items-center justify-center shrink-0">
                      <Download className="w-4 h-4 text-gold-ink" />
                    </div>
                    <div>
                      <span className="font-heading font-bold text-navy text-[13px] block">
                        {t?.utilAdm === 'Penerimaan' ? 'Unduhan Otomatis' : 'Instant Direct Download'}
                      </span>
                      <span className="text-[12px] text-muted block">
                        {t?.utilAdm === 'Penerimaan' ? 'File PDF langsung terunduh setelah formulir dikirim' : 'PDF file downloads immediately upon submission'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column: Form */}
              <div className="lg:col-span-7 bg-white p-6 sm:p-8 rounded-2xl border border-line shadow-sm">
                {downloadFormSubmitted ? (
                  /* Success View */
                  <div className="text-left animate-in fade-in duration-300">
                    <div className="w-14 h-14 rounded-full bg-emerald-500/10 text-emerald-600 flex items-center justify-center mb-4">
                      <CheckCircle2 className="w-7 h-7" />
                    </div>
                    <span className="text-[11px] font-bold tracking-[0.2em] text-emerald-600 uppercase block mb-1">
                      {t?.utilAdm === 'Penerimaan' ? 'Permintaan Berhasil' : 'Request Successful'}
                    </span>
                    <h3 className="text-2xl font-heading font-bold text-navy mb-2">
                      {t?.utilAdm === 'Penerimaan'
                        ? `Terima Kasih, ${downloadFormData.firstName}!`
                        : `Thank You, ${downloadFormData.firstName}!`}
                    </h3>
                    <p className="text-[15px] text-ink/75 leading-relaxed mb-5">
                      {t?.utilAdm === 'Penerimaan'
                        ? 'Rincian PDF Biaya Sekolah GMIS 2027–2028 telah otomatis diunduh ke perangkat Anda.'
                        : 'The full GMIS School Fees 2027–2028 PDF has been automatically downloaded to your device.'}
                    </p>

                    <div className="bg-paper p-4 rounded-xl border border-line/70 mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-[12.5px]">
                      <div>
                        <span className="text-muted block">Lead Reference Code:</span>
                        <span className="font-mono font-bold text-navy text-[14px]">{leadReferenceId}</span>
                      </div>
                      <div className="flex items-center gap-1.5 text-emerald-700 font-semibold bg-emerald-50 px-2.5 py-1 rounded-md border border-emerald-200 w-fit">
                        <Check className="w-3.5 h-3.5" />
                        <span>Recorded in System</span>
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-3">
                      <button
                        onClick={triggerPdfDownload}
                        className="btn inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-gold text-navy-deep font-heading font-bold text-[12.5px] tracking-wider uppercase transition-all shadow-md hover:shadow-lg cursor-pointer"
                      >
                        <Download className="w-4 h-4" />
                        <span>{t?.utilAdm === 'Penerimaan' ? 'Unduh PDF Lagi' : 'Download PDF Again'}</span>
                      </button>
                      <button
                        onClick={handleResetDownloadForm}
                        className="btn inline-flex items-center gap-2 h-11 px-5 rounded-xl border border-navy/20 bg-paper text-navy font-heading font-bold text-[12.5px] tracking-wider uppercase hover:bg-white transition-all cursor-pointer"
                      >
                        <span>{t?.utilAdm === 'Penerimaan' ? 'Kirim Permintaan Lain' : 'Submit Another Request'}</span>
                      </button>
                    </div>
                  </div>
                ) : (
                  /* Form */
                  <div>
                    <div className="flex items-center justify-end mb-4">
                      <span className="text-[12px] text-red-500 font-semibold">* Required</span>
                    </div>

                    <form onSubmit={handleDownloadFormSubmit} className="space-y-4">
                      {downloadFormError && (
                        <div className="p-3.5 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm flex items-start gap-2">
                          <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
                          <span>{downloadFormError}</span>
                        </div>
                      )}

                      {/* Parent's Name */}
                      <div>
                        <label className="block text-[13px] font-heading font-bold text-navy mb-1.5">
                          {t?.utilAdm === 'Penerimaan' ? 'Nama Orang Tua' : "Parent's Name"} <span className="text-red-500">*</span>
                        </label>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          <div>
                            <input
                              type="text"
                              name="firstName"
                              value={downloadFormData.firstName}
                              onChange={handleDownloadInputChange}
                              placeholder="First Name"
                              required
                              className="w-full h-11 px-3.5 rounded-xl border border-line bg-white text-navy text-[14px] placeholder:text-muted/60 focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-all"
                            />
                            <span className="text-[11px] text-muted mt-1 block">First Name</span>
                          </div>
                          <div>
                            <input
                              type="text"
                              name="lastName"
                              value={downloadFormData.lastName}
                              onChange={handleDownloadInputChange}
                              placeholder="Last Name"
                              required
                              className="w-full h-11 px-3.5 rounded-xl border border-line bg-white text-navy text-[14px] placeholder:text-muted/60 focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-all"
                            />
                            <span className="text-[11px] text-muted mt-1 block">Last Name</span>
                          </div>
                        </div>
                      </div>

                      {/* Email Address */}
                      <div>
                        <label className="block text-[13px] font-heading font-bold text-navy mb-1.5">
                          {t?.utilAdm === 'Penerimaan' ? 'Alamat Email' : 'Email Address'} <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={downloadFormData.email}
                          onChange={handleDownloadInputChange}
                          placeholder="e.g. parent@example.com"
                          required
                          className="w-full h-11 px-3.5 rounded-xl border border-line bg-white text-navy text-[14px] placeholder:text-muted/60 focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-all"
                        />
                      </div>

                      {/* WhatsApp Number */}
                      <div>
                        <label className="block text-[13px] font-heading font-bold text-navy mb-1.5">
                          {t?.utilAdm === 'Penerimaan' ? 'Nomor WhatsApp' : 'WhatsApp Number'} <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          name="whatsapp"
                          value={downloadFormData.whatsapp}
                          onChange={handleDownloadInputChange}
                          placeholder="e.g. +62 812-3456-7890"
                          required
                          className="w-full h-11 px-3.5 rounded-xl border border-line bg-white text-navy text-[14px] placeholder:text-muted/60 focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-all"
                        />
                      </div>

                      {/* Consent note */}
                      <p className="text-[12px] text-ink/70 leading-relaxed pt-1 m-0">
                        By submitting this form, I give my consent to GMIS to process my personal information &amp; sensitive personal information for the purpose of this school fees request following the{' '}
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (setPage) setPage('faqs');
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                          className="font-semibold text-navy underline hover:text-gold transition-colors"
                        >
                          GMIS Data Protection &amp; Privacy Policy
                        </a>.
                      </p>

                      {/* Submit Button */}
                      <div className="pt-2">
                        <button
                          type="submit"
                          disabled={isSubmittingDownload}
                          className="px-8 py-2.5 rounded-md border-2 border-navy text-navy font-heading font-bold text-[13px] tracking-wider uppercase hover:bg-navy hover:text-white transition-all shadow-sm flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50"
                        >
                          {isSubmittingDownload ? (
                            <>
                              <Loader2 className="w-4 h-4 animate-spin text-navy" />
                              <span>Processing...</span>
                            </>
                          ) : (
                            <span>Submit</span>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ── Section 3: Promotions & Payment Discounts ─────────────────── */}
        <div id="discounts" className="mb-20 scroll-mt-28">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <div className="inline-flex items-center gap-2 mb-3 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10">
              <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">
                {disc.eyebrow || 'Savings & Incentives'}
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-[40px] font-heading font-bold text-navy tracking-tight m-0 leading-tight uppercase">
              {disc.title || 'Promotions & Payment Discounts'}
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-7">
            {/* Early Bird Promotion Card */}
            <div className="bg-white rounded-3xl p-7 lg:p-8 border border-line shadow-md hover:shadow-xl transition-all duration-300 flex flex-col justify-between relative overflow-hidden group">
              <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/5 rounded-bl-full pointer-events-none" />

              <div>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-12 h-12 rounded-2xl bg-gold/15 text-gold-ink flex items-center justify-center shrink-0">
                    <Sparkles className="w-6 h-6 text-gold" />
                  </div>
                  <div>
                    <span className="text-[11px] font-bold tracking-[0.2em] text-gold uppercase block">
                      {disc.earlyBird?.tag || 'Special Incentive'}
                    </span>
                    <h3 className="text-xl md:text-2xl font-heading font-bold text-navy m-0">
                      {disc.earlyBird?.title || 'Early Bird Promotion'}
                    </h3>
                  </div>
                </div>

                <p className="text-[15px] text-ink/80 leading-relaxed mb-6">
                  {disc.earlyBird?.desc || 'Families enrolling during the Early Bird Promotion period may receive special discounts on school fees for the first academic year.'}
                </p>

                <div className="bg-paper/60 p-4 rounded-2xl border border-line/60 flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0 mt-0.5" />
                  <span className="text-[13.5px] text-ink/85 font-medium leading-relaxed">
                    Applicable to newly admitted students across selected year groups upon timely confirmation.
                  </span>
                </div>
              </div>
            </div>

            {/* Payment Discounts Card */}
            <div className="bg-white rounded-3xl p-7 lg:p-8 border border-line shadow-md hover:shadow-xl transition-all duration-300 flex flex-col justify-between relative overflow-hidden group">
              <div className="absolute top-0 right-0 w-32 h-32 bg-navy/5 rounded-bl-full pointer-events-none" />

              <div>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-12 h-12 rounded-2xl bg-navy/10 text-navy flex items-center justify-center shrink-0">
                    <Percent className="w-6 h-6 text-gold" />
                  </div>
                  <div>
                    <span className="text-[11px] font-bold tracking-[0.2em] text-gold uppercase block">
                      Tuition Settlement
                    </span>
                    <h3 className="text-xl md:text-2xl font-heading font-bold text-navy m-0">
                      {disc.discounts?.title || 'Payment Discounts'}
                    </h3>
                  </div>
                </div>

                {/* 2 Discount Highlight Rows */}
                <div className="space-y-3.5 mb-2">
                  {(disc.discounts?.items || [
                    {
                      percent: '3%',
                      title: 'Semester Settlement Discount',
                      desc: '3% discount applies to the total basic school fee if payment for the semester is settled in full during the registration process.'
                    },
                    {
                      percent: '6%',
                      title: 'Annual Full Settlement Discount',
                      desc: '6% discount applies to the total basic school fee if payment for the entire academic year is settled in full during the registration process.'
                    }
                  ]).map((item, i) => (
                    <div key={i} className="flex items-start gap-3.5 bg-paper/60 p-4 rounded-2xl border border-line/60">
                      <div className="w-12 h-12 rounded-xl bg-gold text-navy-deep font-heading font-extrabold text-[16px] flex items-center justify-center shrink-0 shadow-sm">
                        {item.percent}
                      </div>
                      <div>
                        <span className="font-heading font-bold text-navy text-[14px] block mb-1">
                          {item.title}
                        </span>
                        <p className="text-[13px] text-ink/80 leading-relaxed m-0">
                          {item.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Section 3: Corporate Partnerships ──────────────────────────── */}
        <div className="bg-white rounded-3xl p-8 lg:p-10 border border-line shadow-lg  relative overflow-hidden">
          <div className="absolute top-0 right-0 w-80 h-80 bg-gold/5 rounded-full blur-2xl pointer-events-none" />

          <div className="relative z-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 mb-3 px-3 py-1 rounded-full border border-gold/30 bg-gold/10">
                <Briefcase className="w-3.5 h-3.5 text-gold" />
                <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">
                  {corp.eyebrow || 'Employee Education Benefits'}
                </span>
              </div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-navy mb-3">
                {corp.title || 'Corporate Partnerships'}
              </h3>
              <p className="text-[15px] md:text-[16px] text-ink/80 leading-relaxed m-0">
                {corp.desc || 'GMIS Jakarta works with organisations that value education and family support. If your company is looking for an education partner for employees and their families, our Marketing Team would be happy to discuss corporate partnership opportunities.'}
              </p>
            </div>

            <a
              href="https://wa.me/6281111801448?text=Hello+GMIS+Team,%0A%0AI+would+like+to+enquire+about+your+Corporate+Partnership+Programme.+Could+you+please+share+more+information+about+the+partnership+benefits+and+requirements?%0A%0AThank+you.&utm_source=website"
              target="_blank"
              rel="noopener noreferrer"
              className="btn shrink-0 inline-flex items-center justify-center gap-2.5 h-12 px-7 rounded-xl bg-navy text-white font-heading font-bold text-[13px] tracking-wider uppercase transition-all hover:bg-gold hover:text-navy-deep shadow-md"
            >
              <span>{corp.button || 'Explore Corporate Partnership Opportunities'}</span>
              <ArrowRight className="w-4 h-4 text-gold group-hover:text-navy-deep" />
            </a>
          </div>
        </div>
      </div>

      {/* ── CTA Section (PreschoolPage style) ─────────────────────────────── */}
      <div className="w-full bg-white">
        <div className="max-w-[1200px] mx-auto px-8 py-12">
          <div className="relative overflow-hidden bg-navy rounded-3xl p-12 md:p-20 text-center shadow-2xl">
            <div className="relative z-10">
              <h3 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6 leading-tight uppercase">
                {cta.title || 'Have questions about school fees?'}
              </h3>
              <p className="text-white/70 text-xl max-w-2xl mx-auto mb-10">
                {cta.subtitle || 'Speak with our Admissions Team for fee clarifications, payment schedules, and tailored enrolment support.'}
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <button
                  onClick={handleNavigateToContact}
                  className="bg-gold text-navy px-10 py-4 rounded-full font-bold text-lg tracking-wide hover:bg-white hover:text-navy transition-colors duration-300 cursor-pointer"
                >
                  {cta.button || 'Speak with our Admissions Team'}
                </button>
                <button
                  onClick={handleNavigateToFaqs}
                  className="bg-white/10 text-white px-10 py-4 rounded-full font-bold text-lg tracking-wide hover:bg-white/20 transition-colors duration-300 border border-white/20 cursor-pointer"
                >
                  {cta.faqButton || 'Frequently Asked Questions'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
